// extracted by mini-css-extract-plugin
export var boxItems = "_ay-1";
export var boxItemsLg = "_ay-2";
export var button = "_ay-7";
export var buttonHoverless = "_ay-9";
export var buttonLg = "_ay-8";
export var filterGroupBox = "_ay-0";
export var icon = "_ay-3";
export var iconSecondary = "_ay-6";
export var iconWrapper = "_ay-4";
export var iconWrapperLg = "_ay-5";
export var truncatedLabel = "_ay-a";